import {
  CLIENT_NUTRITION_STATUS_ACTIVE,
  CLIENT_NUTRITION_STATUS_ARCHIVED,
} from "../../../Firestore/nutrition/nutritionPaths";
import { deriveClientNutritionPlanSections } from "../clientNutritionPlanListUtils";

export const ACTIVE_FOLDER_KEY = CLIENT_NUTRITION_STATUS_ACTIVE;
export const ARCHIVED_FOLDER_KEY = CLIENT_NUTRITION_STATUS_ARCHIVED;

export function normalizeClientNutritionFolderKey(value) {
  const normalizedValue = String(value ?? "").trim().toLowerCase();
  return normalizedValue === CLIENT_NUTRITION_STATUS_ARCHIVED
    ? CLIENT_NUTRITION_STATUS_ARCHIVED
    : CLIENT_NUTRITION_STATUS_ACTIVE;
}

export function normalizeClientNutritionPlanId(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function getClientNutritionPendingPlanStatus(
  pendingStatusesByPlanId = {},
  planId,
) {
  const normalizedPlanId = normalizeClientNutritionPlanId(planId);
  if (!normalizedPlanId) {
    return null;
  }

  const pendingStatus =
    pendingStatusesByPlanId &&
    typeof pendingStatusesByPlanId === "object" &&
    Object.prototype.hasOwnProperty.call(
      pendingStatusesByPlanId,
      normalizedPlanId,
    )
      ? pendingStatusesByPlanId[normalizedPlanId]
      : null;

  if (pendingStatus == null) {
    return null;
  }

  return normalizeClientNutritionFolderKey(pendingStatus);
}

export function isClientNutritionPlanMovePending(
  pendingStatusesByPlanId = {},
  planId,
) {
  return getClientNutritionPendingPlanStatus(pendingStatusesByPlanId, planId) != null;
}

export function buildClientNutritionBrowserSections(
  plans,
  pendingStatusesByPlanId = {},
  labels = {},
  language = "en",
) {
  const sectionPlans = deriveClientNutritionPlanSections(
    plans,
    pendingStatusesByPlanId,
    language,
  );

  return [
    {
      folderKey: ACTIVE_FOLDER_KEY,
      title: labels.activeTitle ?? "Active",
      description:
        labels.activeDescription ?? "Active plans will be visible to the athlete.",
      emptyText: labels.activeEmptyText ?? "No active nutrition plans yet.",
      createTooltip: labels.activeCreateTooltip ?? "Create nutrition plan",
      plans: sectionPlans.active,
    },
    {
      folderKey: ARCHIVED_FOLDER_KEY,
      title: labels.archivedTitle ?? "Archived",
      description:
        labels.archivedDescription ??
        "Archived plans will not be visible to the athlete.",
      emptyText: labels.archivedEmptyText ?? "No archived nutrition plans yet.",
      createTooltip: labels.archivedCreateTooltip ?? "Create archived nutrition plan",
      plans: sectionPlans.archived,
    },
  ];
}

export function getClientNutritionFolderTargetFromOver(overData) {
  if (!overData || overData.type !== "nutritionPlanFolderDropTarget") {
    return null;
  }

  if (typeof overData.folderKey !== "string") {
    return null;
  }

  return normalizeClientNutritionFolderKey(overData.folderKey);
}

export function isClientNutritionCrossFolderMove(sourceFolderKey, targetFolderKey) {
  return (
    normalizeClientNutritionFolderKey(sourceFolderKey) !==
    normalizeClientNutritionFolderKey(targetFolderKey)
  );
}
